export default function ConsentError({
  error: _err,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8">
      <div className="w-full max-w-md space-y-6 rounded-lg bg-surface-card p-8 shadow-sm text-center">
        <h2 className="text-xl font-semibold text-text-primary">
          Something went wrong
        </h2>
        <p className="text-text-muted">
          We couldn't load the authorization page. Please try again.
        </p>
        <button
          type="button"
          onClick={reset}
          className="px-4 py-2 bg-text-primary text-surface-base rounded-md hover:opacity-90"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
